export default __webpack_public_path__ + "static/media/GL Solo 3v3.e391f19d.png";